"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconAccount = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var IconAccount = function IconAccount(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M12.19 11.42c2.555 0 4.628-1.998 4.628-4.462 0-2.466-2.073-4.464-4.629-4.464-2.555 0-4.628 1.998-4.628 4.464 0 2.464 2.073 4.463 4.628 4.463zm-8.71 4.2c1.786 2.834 5.019 4.728 8.71 4.728 3.69 0 6.923-1.894 8.708-4.728a.433.433 0 00-.097-.221c-1.142-1.376-2.948-2.193-5.371-2.193H8.949c-2.424 0-4.23.817-5.371 2.193a.433.433 0 00-.098.22z",
    fillRule: "evenodd"
  }));
};
exports.IconAccount = IconAccount;